import publicApi from './publicApi'

export const getPublicEventTypes = async ({ access_token }: { access_token: string }) => {
  const res = await publicApi.get(`/event_types/`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const getPublicEvent = async ({ id, access_token }: { id: string; access_token: string }) => {
  const res = await publicApi.get(`/events/${id}/`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const getPublicPackages = async ({
  access_token,
  data,
}: {
  access_token: string
  data: {
    type: string
  }
}) => {
  const res = await publicApi.get(`/packages/`, {
    params: data,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const putPublicJoinEvent = async ({
  id,
  access_token,
  private_code,
  data,
}: {
  id: string
  access_token: string
  private_code: string
  data: {
    use_package: boolean
    confirmed?: boolean
    coupon_code?: string
  }
}) => {
  const res = await publicApi.put(`/events/${id}/join/`, data, {
    params: {
      private_code: private_code,
    },
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const postPublicJoinEvent = async ({
  id,
  access_token,
  private_code,
  data,
}: {
  id: string
  access_token: string
  private_code: string
  data: {
    use_package: boolean
    confirmed?: boolean
  }
}) => {
  const res = await publicApi.post(`/events/${id}/join/`, data, {
    params: {
      private_code: private_code,
    },
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const getPublicClassDetails = async ({
  id,
  access_token,
  coupon_code,
}: {
  id: string
  access_token: string
  coupon_code: string | null
}) => {
  const res = await publicApi.get(`/packages/${id}/`, {
    params: { coupon_code }, // Include coupon_code in params
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const postPublicBuyPackageDiscount = async ({
  id,
  access_token,
  private_code,
  coupon_code,
}: {
  id: string
  access_token: string
  private_code: string
  coupon_code: string
}) => {
  const res = await publicApi.post(
    `/packages/${id}/`,
    {
      coupon_code: coupon_code,
    },
    {
      params: {
        private_code: private_code,
      },
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  )

  return res.data
}

export const postPublicBuyPackage = async ({
  id,
  access_token,
  private_code,
}: {
  id: string
  access_token: string
  private_code: string
}) => {
  const res = await publicApi.post(
    `/packages/${id}/`,
    {},
    {
      params: {
        private_code: private_code,
      },
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  )

  return res.data
}

export const postConfirmPayment = async ({
  access_token,
  payment_intent_id,
}: {
  access_token: string
  payment_intent_id: string
}) => {
  const res = await publicApi.post(
    `/events/confirm-payment/`,
    { payment_intent_id },
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  )
  return res.data
}

export const postPublicInvite = async ({
  id,
  access_token,
  data,
}: {
  id: string
  access_token: string
  data: {
    member: string
  }
}) => {
  const res = await publicApi.post(`/events/${id}/invite/`, data, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}

export const getPublicMembers = async ({
  access_token,
  data,
}: {
  access_token: string
  data: {
    search?: string
    page: number
    page_size: number
    exclude_ids?: string
  }
}) => {
  const res = await publicApi.get(`member/`, {
    params: data,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  })

  return res.data
}
